import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../components/Header";
import { ChangePasswordModal } from "../components/profile/ChangePasswordModal";
import { DeleteAccountModal } from "../components/profile/DeleteAccountModal";
import { useAnalytics } from "../lib/analytics";
import { useClientTranslations } from "../lib/i18n/client";
import styles from "./SecuritySettings.module.css";

export function SecuritySettings() {
	const { t, direction } = useClientTranslations("profile");
	const { logProfile } = useAnalytics();
	const navigate = useNavigate();
	const [openModal, setOpenModal] = useState<
		"change-password" | "delete-account" | null
	>(null);

	useEffect(() => {
		logProfile("security_settings_page_viewed");
	}, [logProfile]);

	return (
		<div className={styles.wrapper}>
			<Header />
			<main className={styles.main} dir={direction}>
				<div className={styles.container}>
					<div className={styles.heading}>
						<button
							type="button"
							className={styles.backButton}
							onClick={() => {
								logProfile("security_back_clicked");
								navigate("/settings");
							}}
							aria-label={t("settings.back")}
						>
							&#8249;
						</button>
						<h1 className={styles.title}>{t("settings.cards.security")}</h1>
						<p className={styles.subtitle}>{t("settings.securitySubtitle")}</p>
					</div>

					<div className={styles.buttonGroup}>
						<button
							type="button"
							className={styles.actionButton}
							onClick={() => {
								logProfile("security_change_password_clicked");
								setOpenModal("change-password");
							}}
						>
							<span>{t("changePassword")}</span>
							<svg
								className={styles.actionIcon}
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<title>Password</title>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
								/>
							</svg>
						</button>

						<button
							type="button"
							className={`${styles.actionButton} ${styles.danger}`}
							onClick={() => {
								logProfile("security_delete_account_clicked");
								setOpenModal("delete-account");
							}}
						>
							<span>{t("deleteAccount.buttonText")}</span>
							<svg
								className={styles.actionIcon}
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<title>Delete Account</title>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
								/>
							</svg>
						</button>
					</div>
				</div>
			</main>

			<ChangePasswordModal
				isOpen={openModal === "change-password"}
				onClose={() => setOpenModal(null)}
			/>
			<DeleteAccountModal
				isOpen={openModal === "delete-account"}
				onClose={() => setOpenModal(null)}
			/>
		</div>
	);
}
